import React from "react";
import { formatPriceAmount } from "../../utils/formatPrice";

export interface PriceDisplayProps {
  amount: number | string | null | undefined;
  size?: "sm" | "md" | "lg" | "xl";
  className?: string;
  currencyClassName?: string;
  amountClassName?: string;
}

export const PriceDisplay: React.FC<PriceDisplayProps> = ({
  amount,
  size = "md",
  className = "",
  currencyClassName = "",
  amountClassName = "",
}) => (
  <span
    className={`price-display price-display--${size} ${className}`.trim()}
  >
    <span className={`price-display__currency ${currencyClassName}`.trim()}>
      MAD
    </span>
    <span className={`price-display__amount ${amountClassName}`.trim()}>
      {formatPriceAmount(amount)}
    </span>
  </span>
);
